
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {  LOCALE_ID, NgModule } from '@angular/core';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { CommonModule, LocationStrategy, PathLocationStrategy, registerLocaleData } from '@angular/common';

import { AuthService } from './providers/auth.provider';
import { AthleteRouteLogged, CLubStaffRouteLogged, LoginRouteLogged, NewAccountClubStaffRoute, NewAccountScoutRoute, NewAccountStfStaffRoute, ParentRouteLogged, PortalRouteLogged, ScoutClubStaffRouteLogged, ScoutRouteLogged, StepRouteLogged, StfStaffRouteLogged } from './can-activates/loginguard.provider';
import { UtilitiesService } from './providers/utilities.provider';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { InternationalizationModule } from './modules/internationalization/internationalization.module';
import { CompleteProfileRoute, ProfileRouteLogged, RolesManagementRouterLogged } from './can-activates/profileguard.provider';
import { AthletePendingRoute } from './can-activates/athletesguard.provider';
import { AthleteService } from './providers/athlete/athlete.service';
import { YouTubePlayerModule } from '@angular/youtube-player';

import localeUs from '@angular/common/locales/en';
import { HistorialClubStaffRouteLogged } from './can-activates/reportsguard.provider';
import { MatIconModule } from '@angular/material/icon';

registerLocaleData(localeUs, 'en');

export const CAN_ACTIVATES = [
  LoginRouteLogged,
  NewAccountClubStaffRoute,
  NewAccountStfStaffRoute,
  NewAccountScoutRoute,
  StepRouteLogged,
  ProfileRouteLogged,
  PortalRouteLogged,
  AthletePendingRoute,
  CompleteProfileRoute,
  HistorialClubStaffRouteLogged,
  AthleteRouteLogged,
  ParentRouteLogged,
  CLubStaffRouteLogged,
  ScoutRouteLogged,
  StfStaffRouteLogged,
  ScoutClubStaffRouteLogged,
  RolesManagementRouterLogged
]

/**
* The http loader factory : Loads the files from define path.
* @param {HttpClient} http
* @returns {TranslateHttpLoader}
* @constructor
*/
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    YouTubePlayerModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    NgxQRCodeModule,
    InternationalizationModule.forRoot({ locale_id: 'en-US' }), // iniating with default language: en-US
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    MatIconModule
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: LOCALE_ID, useValue: "en" },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
  
    AuthService,
    UtilitiesService,
    TranslateService,
    AthleteService,
    ...CAN_ACTIVATES
  ]
})
export class AppModule {
}
